import { render, staticRenderFns } from "./PaymentSystemSuccess.vue?vue&type=template&id=74f07b27&scoped=true&"
import script from "./PaymentSystemSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentSystemSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSystemSuccess.vue?vue&type=style&index=0&id=74f07b27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f07b27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCard,VCol,VContainer,VIcon,VImg,VRow})
